// extracted by mini-css-extract-plugin
export default {"buttonStartNaviComponent":"ButtonStartNaviComponent_buttonStartNaviComponent__yLw-Y"};